module.exports = __webpack_public_path__ + "static/media/SF-UI-Text-Medium.c79140b9.woff2";